import { createAction, props } from '@ngrx/store';
import { ChangelogVersion } from './changelog-version.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records changelog-version'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records changelog-version success', 
    props<{ listData: ChangelogVersion[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records changelog-version failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record changelog-version',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record changelog-version success', 
    props<{ singleData: ChangelogVersion }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record changelog-version failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record changelog-version',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record changelog-version success'
);
export const addRecordFailure = createAction(
    '[Data] Add record changelog-version failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record changelog-version',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record changelog-version success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record changelog-version failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record changelog-version',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record changelog-version success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record changelog-version failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state changelog-version',
);